import { subdomainLink, inViewer } from './url'
import create, {createPublic} from './command'
import {logout} from 'context/post'

export const getProfile = createPublic('myinfo')

export function getFullName ({first_name, middle_name, last_name, maiden_name}) {
  return `${first_name} ${middle_name || ''} ${last_name} ${maiden_name || ''}`
}

export function createLogoutHandler (language, project) {
  return async () => {
    await logout()
    const url = inViewer ? '//logout' : subdomainLink(project == 'de' ? 'de' : 'www', language, 'login.html')
    location.replace(url)
  }
}

export async function keepAlive () {
    return create('security', 'keepAlive')()
}
